<lib-page-layout>
  <lib-title-navbar pageHeader title="Polityka prywatnosci"></lib-title-navbar>

  <div class="or-my-32-px or-mx-28-px">
    <div class="or-head-lg">POLITYKA PRYWATNOŚCI I PLIKÓW COOKIES</div>

    <p class="or-text-md">
      Mają Państwo prawo między innymi do dostępu do swoich danych, ich poprawiania, a także żądania ich usunięcia.
      Ponadto przysługuje Państwu prawo do wniesienia sprzeciwu co do przetwarzania Państwa danych osobowych lub żądanie
      ograniczenia ich przetwarzania.
    </p>

    <p class="or-text-md">
      Podanie przez Państwa wymaganych danych osobowych jest dobrowolne, ale stanowi warunek świadczenia przez nas
      określonych usług na rzecz Państwa (np. prowadzenia konta) lub realizacji umowy. Nie podejmujemy wobec Państwa
      indywidualnych decyzji opierających się wyłącznie na zautomatyzowanym przetwarzaniu (profilowaniu), które
      wywoływałyby skutki prawne lub w podobny sposób istotnie wpływały na Państwa sytuację.
    </p>

    <p class="or-text-md">
      Poniżej znajdą Państwo wszystkie najistotniejsze kwestie związane z przetwarzaniem danych osobowych w naszej
      Aplikacji oraz stronie internetowej (www.orlikfy.pl).
    </p>

    <div class="or-head-md">Kto jest administratorem Aplikacji oraz danych osobowych?</div>
    <p class="or-text-md">
      Administratorem Aplikacji oraz danych osobowych jest Dominik Króliczek prowadzący działalność pod firmą Dominik
      Króliczek Yeah Bunny Soft, adres siedziby: ul. Mielęckiego 10, lok. 503, 40-001 Katowice, NIP: 5512604761, REGON:
      381599361.
    </p>
    <p class="or-text-md">Dane kontaktowe: {{ 'orlikfyapp@gmail.com' }}, nr tel. +48 783 247 081.</p>

    <div class="or-head-md">Jaka jest podstawa prawna przetwarzania danych osobowych?</div>
    <p class="or-text-md">
      Dane osobowe są zbierane i przetwarzane zgodnie z przepisami Rozporządzenia Parlamentu Europejskiego i Rady (UE)
      2016/679 z dnia 27 kwietnia 2016 roku w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych
      osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie
      o ochronie danych) (RODO). Przetwarzanie danych osobowych jest regulowane także przez krajową ustawę z dnia 10
      maja 2018 r. o ochronie danych osobowych (t.j. Dz. U. z 2019 r. poz. 1781).
    </p>

    <div class="or-head-md">Jakie dane przetwarzamy?</div>
    <p class="or-text-md">
      W zależności od celu oraz preferencji użytkownika, możemy przetwarzać takie dane jak: imię i nazwisko, adres,
      adres e-mail, numer telefonu, adres IP oraz wizerunek w przypadku dodania zdjęcia profilowego. Ponadto możemy
      przetwarzać inne dane osobowe skierowane w korespondencji do nas. Dla celów związanych z analityką możemy
      przetwarzać także dane dotyczące źródła przejścia do Aplikacji lub na stronę, systemu operacyjnego i przeglądarki
      internetowej wykorzystywanych do przeglądania strony, czasu spędzonego na stronie, aktywności w Aplikacji,
      przedziału wieku użytkownika, płci, przybliżonej lokalizacji oraz zainteresowań (na podstawie aktywności w sieci).
    </p>

    <p class="or-text-md">Powyższe dane są nam przekazywane na skutek działań takich jak:</p>
    <ul class="or-text-md">
      <li>Skorzystanie z formularza kontaktowego,</li>
      <li>Przesłanie korespondencji bezpośrednio na nasz adres e-mail,</li>
      <li>Przekazanie nam danych w toku rozmowy telefonicznej,</li>
      <li>Rejestracja Konta w Aplikacji,</li>
      <li>Tworzenia wydarzenia sportowego,</li>
      <li>Dołączanie do wydarzenia sportowego,</li>
      <li>Edycji Konta w Aplikacji,</li>
      <li>
        Zgromadzenie danych pozostałych danych służących analityce przez oprogramowanie Aplikacji lub narzędzia
        wymienione w tej Polityce Prywatności.
      </li>
    </ul>

    <div class="or-head-md">W jakich celach przetwarzamy Państwa dane?</div>
    <p class="or-text-md">
      Dane przetwarzamy w zakresie istotnym dla funkcjonowania naszej Aplikacji oraz strony i przechowujemy je przez
      okres dozwolony przez przepisy. Przetwarzamy dane dostarczone przez użytkowników w czasie korzystania z Aplikacji
      i/lub strony:
    </p>

    <ul class="or-text-md">
      <li>Zawarcie i wykonanie umowy – na podstawie art. 6 ust. 1 lit. b) RODO...</li>
      <li>Założenie i utrzymanie konta - na podstawie art. 6 ust. 1 lit. b) RODO...</li>
      <li>Zapewnienie kontaktu – art. 6 ust. 1 lit. b) RODO...</li>
      <li>Marketing bezpośredni – art. 6 ust. 1 lit. a) lub f) RODO...</li>
      <li>Wypełnianie obowiązków prawnych – art. 6 ust. 1 lit. c) oraz f) RODO...</li>
      <li>Działania analityczne i statystyczne – art. 6 ust. 1 lit. f) RODO...</li>
    </ul>

    <p class="or-text-md">
      Korzystamy z narzędzi takich jak Facebook Ads oraz Google Ads, w ramach których możemy kierować reklamy do
      określonych grup docelowych opartych o zainteresowania, płeć, wiek, wykonywany zawód. Narzędzia te zostały
      szczegółowo opisane w polityce plików cookies.
    </p>

    <div class="or-head-md">Komu przekazujemy dane osobowe?</div>
    <p class="or-text-md">
      Dane osobowe przekazujemy innym podmiotom jedynie w zakresie, w jakim osoba, której dane dotyczą, wyraziła zgodę
      na przetwarzanie danych, w jakim jest to potrzebne do realizacji umowy lub w zakresie jaki wynika z prawnie
      uzasadnionych interesów realizowanych przez administratora. Są to współpracujący z administratorem: hostingodawca,
      dostawca systemu CRM oraz systemu do fakturowania, biuro rachunkowe, dostawcy narzędzi marketingowych oraz inni
      podwykonawcy, a także podmioty którym jesteśmy zobowiązani przekazać Twoje dane na mocy obowiązujących przepisów.
    </p>
    <p class="or-text-md">
      W przypadku danych dotyczących analityki i statystyki, które nie stanowią danych osobowych, mogą one zostać
      przekazane do firm świadczących powszechnie usługi z zakresu analityki, statystyki i optymalizacji, w tym do
      Stanów Zjednoczonych (np. firmy: Google LLC, Meta Platforms Inc.).
    </p>

    <div class="or-head-md">Czy dane są przekazywane do państw trzecich lub organizacji międzynarodowych?</div>
    <p class="or-text-md">
      Część operacji przetwarzania danych może wiązać się z przekazywaniem ich do państw trzecich lub organizacji
      międzynarodowych w związku z korzystaniem z narzędzi, które przechowują dane osobowe na serwerach zlokalizowanych
      w państwach trzecich, szczególnie USA.
    </p>
    <p class="or-text-md">
      Należy jednak wskazać, że dostawcy tych narzędzi gwarantują odpowiedni poziom ochrony danych osobowych, w
      szczególności poprzez przystąpienie do programu Data Privacy Framework lub korzystanie ze standardowych klauzul
      umownych. Dotyczy to w szczególności usług Google Ireland Limited.
    </p>

    <div class="or-head-md">Jakie dokładnie masz prawa w związku z przetwarzaniem Twoich danych osobowych?</div>
    <ul class="or-text-md">
      <li>żądania dostępu do swoich danych osobowych,</li>
      <li>żądania sprostowania swoich danych osobowych,</li>
      <li>wniesienia sprzeciwu wobec przetwarzania danych osobowych,</li>
      <li>żądania usunięcia swoich danych osobowych,</li>
      <li>żądania ograniczenia przetwarzania danych osobowych,</li>
      <li>żądania przenoszenia danych osobowych,</li>
      <li>
        uzyskania informacji o zautomatyzowanym podejmowaniu decyzji, w tym o profilowaniu oraz o zabezpieczeniach
        stosowanych w związku z przekazaniem tych danych poza UE,
      </li>
      <li>
        uzyskania informacji o celach przetwarzania, kategoriach przetwarzanych danych osobowych, o odbiorcach lub
        kategoriach odbiorców tych danych,
      </li>
      <li>
        uzyskania informacji o prawach przysługujących na mocy RODO, o prawie wniesienia skargi do PUODO, o planowanym
        okresie przechowywania danych lub o kryteriach ustalania tego okresu, o źródle tych danych,
      </li>
      <li>uzyskania kopii swoich danych osobowych.</li>
    </ul>
    <p class="or-text-md">
      Jeżeli chcesz zrealizować którekolwiek z wyżej wspominanych praw, poinformuj nas. Niezwłocznie udzielimy Tobie
      wszelkich informacji o działaniach podjętych w związku ze zgłoszonym żądaniem.
    </p>
    <p class="or-text-md">
      Możesz cofnąć udzieloną nam zgodę na przetwarzanie swoich danych osobowych w dowolnym momencie. W tym celu prosimy
      o kontakt z nami.
    </p>

    <div class="or-head-md">Polityka plików cookies</div>
    <p class="or-text-md">
      Pliki cookies to występujące powszechnie krótkie informacje tekstowe, które pozwalają zidentyfikować
      wykorzystywane oprogramowanie, dostosować treści do potrzeb użytkownika oraz zapewnić poprawne działanie
      Aplikacji. Są one zapisywane na urządzeniu, z którego korzystasz i posiadają nazwę domeny, czas przechowywania
      oraz określoną wartość. Pliki cookies stosowane w naszej Aplikacji są bezpieczne i dzielą się na cookies sesyjne
      oraz trwałe. Cookies sesyjne są przechowywane jedynie do momentu zakończenia sesji danej przeglądarki. Cookies
      trwałe są przechowywane na urządzeniu do momentu ich skasowania.
    </p>
    <p class="or-text-md">
      Za pomocą swojej przeglądarki internetowej w każdej chwili możesz zmienić swoje preferencje dot. cookies lub je
      usunąć (cookies trwałe).
    </p>

    <div class="or-head-md">Podstawa wykorzystywania plików cookies</div>
    <p class="or-text-md">
      Część plików cookies wykorzystujemy w zakresie niezbędnym do prawidłowego świadczenia usług drogą elektroniczną,
      pozostałe pliki cookies wykorzystujemy na podstawie udzielonej zgody.
    </p>
    <p class="or-text-md">
      Udzielona zgoda wynika z ustawień przeglądarki internetowej, innego oprogramowania służącego do zarządzania
      plikami cookies lub ustawień menadżera cookies w przypadku jego udostępnienia w Aplikacji.
    </p>
    <p class="or-text-md">
      Możesz wyłączyć pliki cookies, a także poszczególne ich rodzaje. Zastrzegamy jednak, że w przypadku wyłączenia lub
      ograniczenia obsługi plików cookies, możesz utracić dostęp do części funkcjonalności dostępnych w Aplikacji, dla
      których funkcjonowania niezbędna jest zgoda na wykorzystywanie określonych plików cookies.
    </p>

    <div class="or-head-md">Podmioty, których pliki cookies wykorzystujemy:</div>
    <p class="or-text-md">
      Narzędzia Google - Google Analytics, Google Ads, Google Adsense, Google Tag Manager, a także należący do Google
      YouTube, dostarczane przez Google Ireland Limited (Registration Number: 368047 / VAT Number: IE6388047V), Gordon
      House, Barrow Street, Dublin 4, Ireland. Działania dotyczące korzystania z tych narzędzi opieramy na naszym
      prawnie uzasadnionym interesie dotyczącym marketingu przy użyciu powszechnie używanych narzędzi. Z naszej
      perspektywy dane gromadzone w związku z korzystaniem z tych narzędzi nie mają charakteru danych osobowych ze
      względu na anonimizację.
    </p>
    <p class="or-text-md">
      Więcej informacji na temat narzędzi znajdą Państwo w Regulaminie oraz Polityce Prywatności Google.
    </p>

    <div class="or-head-md">Google Analytics</div>
    <p class="or-text-md">
      Korzystamy z narzędzia Google Analytics w celach związanych z analityką i statystyką, które służą poprawieniu
      działania naszej Aplikacji. Dane gromadzone w związku z korzystaniem z narzędzia nie mają charakteru danych
      osobowych ze względu na anonimizację i obejmują badanie ruchu użytkownika w Aplikacji (informacje o systemie
      operacyjnym, przeglądarce, odwiedzane zakładki, czas spędzony w Aplikacji, źródło przejścia do Aplikacji).
    </p>

    <div class="or-head-md">Google Ads</div>
    <p class="or-text-md">
      Gdy odwiedzają Państwo naszą Aplikację, na Państwa urządzeniu pozostawiane są pliki cookies związane z
      remarketingiem, które zbierają informacje dotyczące aktywności w Aplikacji. Zebrane informacje służą wyświetlaniu
      reklam w sieci Google, które odpowiadają Państwa aktywnościom i zainteresowaniom. Jeżeli wyrazili Państwo na to
      zgodę wobec Google, dane te mogą być także dalej przetwarzane przez tę firmę np. w celu utworzenia grup
      docelowych.
    </p>
    <p class="or-text-md">
      W przypadku braku chęci otrzymywania spersonalizowanych reklam, możliwe jest zdefiniowanie ustawień na stronie
      <a href="https://myadcenter.google.com" target="_blank">myadcenter.google.com</a>.
    </p>

    <div class="or-head-md">Google AdSense</div>
    <p class="or-text-md">
      W Aplikacji mogą być wyświetlane personalizowane reklamy w ramach sieci AdSense. Pliki cookies wykorzystywane są
      do wyświetlania reklam na podstawie odwiedzin oraz aktywności na naszej stronie lub na innych stronach.
    </p>

    <div class="or-head-md">GetStream</div>
    <p class="or-text-md">
      Korzystamy z narzędzia GetStream dostarczanej przez Stream.io Inc., dzięki któremu Użytkownicy mogą korzystać z
      czatu i kontaktować się z innymi Użytkownikami. Więcej informacji znajdą Państwo w Polityce Prywatności GetStream.
    </p>

    <div class="or-head-md">Piksel Meta</div>
    <p class="or-text-md">
      Korzystamy z narzędzi marketingowych dostępnych w ramach serwisu Facebook i zapewnianych przez Meta Platforms
      Ireland Limited. Piksel Meta to krótki kod umieszczany w witrynie, który pozwala mierzyć skuteczność reklam na
      podstawie analizy działań podejmowanych przez użytkowników w witrynie oraz personalizować reklamy. Celem kodu jest
      wyświetlanie reklam właściwym odbiorcom, zwiększenie sprzedaży oraz pomiar wyników reklam.
    </p>
    <p class="or-text-md">
      Piksel Meta używa plików cookies rejestrujących działania w witrynie – przykładowo ruch w Aplikacji, czy
      odwiedzanie konkretnych podstron. Analiza tych działań służy optymalizacji działania Aplikacji.
    </p>
    <p class="or-text-md">Więcej informacji znajdą Państwo w Polityce Prywatności firmy Meta.</p>

    <div class="or-head-md">Media społecznościowe</div>
    <p class="or-text-md">
      W przypadku zamieszczenia przez nas w Aplikacji wtyczki do danej platformy społecznościowej (Facebook, Instagram,
      LinkedIn, Twitter), administrator danego serwisu otrzymuje informację o odwiedzinach naszej Aplikacji używając
      identyfikatora użytkownika. Administrator danej platformy zbiera informacje o używanej przeglądarce, dacie oraz
      godzinie odwiedzin Aplikacji. Administratorzy danej platformy używają tych informacji do zapewnienia pełnej
      funkcjonalności wtyczek oraz do doskonalenia swoich usług, a także personalizowania reklam.
    </p>
    <p class="or-text-md">
      Więcej informacji znajdą Państwo w Polityce Prywatności firmy Meta oraz w Polityce Prywatności LinkedIn oraz
      Twittera.
    </p>

    <div class="or-head-md">wp.pl</div>
    <p class="or-text-md">
      Aplikacja może korzystać z plików cookies umożliwiających reklamowanie w ramach usług świadczonych przez Wirtualna
      Polska Media S.A z siedzibą w Warszawie. Więcej informacji znajdą Państwo w Polityce Prywatności firmy WP.
    </p>

    <div class="or-head-md">Logi serwera</div>
    <p class="or-text-md">
      Korzystanie z Aplikacji wiąże się z przesyłaniem zapytań do serwera, które zapisywane są w tzw. logach serwera.
      Zawierają one m.in. informacje o adresie IP użytkownika, dacie i czasie zapytania, przeglądarce oraz systemie
      operacyjnym.
    </p>
    <p class="or-text-md">
      Logi serwera są zapisywane i przechowywane na serwerze. Nie są jednak wiązane z konkretnymi osobami korzystającymi
      z Aplikacji i nie mają na celu identyfikacji – służą jedynie do administrowania Aplikacją, a ich treść nie jest
      ujawniana nieuprawnionym osobom.
    </p>
  </div>
</lib-page-layout>
